import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationStatusDto {
    id: number;
    applicationId: number;  // used when updating a single application
    statusDate: Date;
    status: string;
    subStatus: string;
    hearingId: number;
    hearingDate: Date;
    applicationIds: number[];   // used when doing Batch updates
    /*
    public create() {
        return {
            id: 0,
            applicationId: 0,
            statusDate: null,
            status: '',
            subStatus: '',
            hearingId: 0,
            hearingDate: null,
            applicationIds: [],
        }
    }
    */
}